<!--
 * @Author: your name
 * @Date: 2021-05-20 11:07:43
 * @LastEditTime: 2021-06-03 16:25:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \VtpWechatUI\src\App.vue
-->
<template>
    <div id="app" :style="{'height':screenWidth+'px'}">
        <!-- <img src="./assets/logo.png"> -->
        <router-view />
    </div>
</template>

<script>
import store from '@/store/index'
export default {
    name: 'App',
    data() {
        return {
            screenWidth: document.body.clientHeight // 屏幕高
        }
    },
    created() {
        // 在页面加载时读取sessionStorage里的状态信息
        if (sessionStorage.getItem("store")) {
            store.replaceState(Object.assign({}, store.state, JSON.parse(sessionStorage.getItem("store"))))
        }
        // 在页面刷新时将vuex里的信息保存到sessionStorage里
        var isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
        if (isiOS) {
            // 在页面刷新时将vuex里的信息保存到缓存里
            window.addEventListener("pagehide", () => {
                sessionStorage.setItem("store", JSON.stringify(this.$store.state))
            })
        } else {
            // 在页面刷新时将vuex里的信息保存到缓存里
            window.addEventListener("beforeunload", () => {
                sessionStorage.setItem("store", JSON.stringify(this.$store.state))
            })
        }
        // window.addEventListener("unload", () => {
        //     alert(111)
        //     sessionStorage.setItem("store", JSON.stringify(store.state))
        // })
    }
}
</script>

<style>
html,
body,
#app {
    height: 99%;
    width: 100%;
    background-color: rgb(245, 245, 245);
}
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
    color: #2c3e50;
}
.line {
    margin-top: 5px;
    background-color: rgb(246, 246, 246);
    height: 2px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue